import React, {useState} from 'react';
import PropTypes from 'prop-types';

import AssignButton from "./components/AssignButton";
import ReclaimButton from "./components/ReclaimButton";
import RunnerName from "./components/RunnerName";
import RunnerAvatar from "./components/RunnerAvatar";

import {assign} from "api/order/assign";
import {sessionStore} from "utils/sessionStore";

Runner.propTypes = {
    orderId: PropTypes.string,
    lineItems: PropTypes.array,
};

function getUniqueRunners(lineItems) {
    const runners = [];
    const seenIds = new Set();

    lineItems.forEach((lineItem) => {
        const runner = lineItem.runner;

        if (runner && runner['@id'] && !seenIds.has(runner['@id'])) {
            seenIds.add(runner['@id']);
            runners.push(runner);
        }
    });

    return runners;
}

function Runner({orderId, lineItems = []}) {
    const [localLineItems, setLocalLineItems] = useState(lineItems);
    const [assigning, setAssigning] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    const member = sessionStore.get('member');

    const unassignedLineItems = localLineItems.filter((lineItem) => !lineItem.runner);
    const runners = getUniqueRunners(localLineItems);

    async function handleAssign(event) {
        event.stopPropagation();

        setAssigning(true);

        const updatedOrder = await assign({id: orderId}, {runner: member.id});

        setLocalLineItems(updatedOrder.lineItems);

        setAssigning(false);
    }

    const hasSingleRunner = runners.length === 1;
    // pas de reprise à proposer sur une commande déjà affectée à soi-même
    const isAssignedToMe = runners.length > 0 && runners.every((runner) => runner['@id'] === `/members/${member.id}`);
    const showReclaim = runners.length > 0 && !isAssignedToMe && (isHovered || assigning);

    return (
        <div style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
            {runners.length > 0 && (
                <div
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    {showReclaim ? (
                        <ReclaimButton loading={assigning} onClick={handleAssign} />
                    ) : hasSingleRunner ? (
                        <RunnerName runner={runners[0]} />
                    ) : (
                        <div style={{display: 'flex'}}>
                            {runners.map((runner, index) => (
                                <div
                                    key={runner['@id']}
                                    style={{
                                        position: 'relative',
                                        zIndex: runners.length - index,
                                        marginLeft: index === 0 ? 0 : '-8px'
                                    }}
                                >
                                    <RunnerAvatar runner={runner} />
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}

            {unassignedLineItems.length > 0 && (
                <AssignButton loading={assigning} onClick={handleAssign} />
            )}
        </div>
    );
}

export default Runner;
